<template>
  <v-row>
    <v-col>
      <v-container class="pa-6 pt-0">
        <h2>{{ testName }}</h2>
        <points-measured-card />
        <h2>{{ pointName }}</h2>
        <niko-slider
          :label="$t('tests.illumination.measured')"
          :min="-1"
          :max="1500"
          suffix="lux"
          step="1"
          :value="measuredLux"
          @onChange="(value) => (measuredLux = value)"
          v-model="measuredLux"
          placeholder="-"
        ></niko-slider>

        <point-distances-card />
      </v-container>
      <v-toolbar
        absolute
        bottom
        color="#1A1A1A"
        style="border-top: 1px solid #4c4c4c !important"
        class="px-6"
        height="76px"
        width="100%"
      >
        <v-row align-content="space-between">
          <v-col cols="12" class="d-flex justify-end pa-0">
            <niko-button
              :text="
                isLastPointBeingMeasured && !existingResult
                  ? $t('tests.button.finish')
                  : $t('tests.button.next')
              "
              @onClick="savePointResultClicked"
              primary
            ></niko-button
          ></v-col>
        </v-row>
      </v-toolbar>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import NikoSlider from "../UI/NikoSlider";
import PointsMeasuredCard from "./PointsMeasuredCard";
import PointDistancesCard from "./PointDistancesCard";
import NikoButton from "../UI/NikoButton";

export default {
  name: "tester-point-view",
  components: {
    PointsMeasuredCard,
    PointDistancesCard,
    NikoSlider,
    NikoButton,
  },
  data: () => ({
    measuredLux: null,
  }),
  computed: {
    ...mapState("roomStore", [
      "illumination_tests",
      "selected_test_id",
      "measurement_points",
      "selected_measurement_point_id",
    ]),
    ...mapState("projectStore", ["equipments"]),
    testName() {
      return this.illumination_tests.find(
        (test) => test.illumination_test_id === this.selected_test_id
      ).name;
    },
    pointName() {
      const location = this.measurement_points.find(
        (point) =>
          point.measurement_point_id === this.selected_measurement_point_id
      ).location;
      return this.$i18n.t("tests.illumination.point", { location });
    },
    existingResult() {
      return this.illumination_tests
        .find((test) => test.illumination_test_id === this.selected_test_id)
        .illumination_test_results.find(
          (result) =>
            result.measurement_point_id === this.selected_measurement_point_id
        );
    },
    isLastPointBeingMeasured() {
      return (
        this.measurement_points.filter((point) => point.is_active).length ===
        this.illumination_tests.find(
          (test) => test.illumination_test_id === this.selected_test_id
        ).illumination_test_results.length +
          1
      );
    },
  },
  methods: {
    ...mapActions("projectStore", [
      "addIlluminationTestResult",
      "updateIlluminationTestResult",
      "deleteIlluminationResult",
    ]),
    ...mapMutations("roomStore", ["setSelectedMeasurementPointId"]),
    savePointResultClicked() {
      const illumination_test_result = {
        measurement_point_id: this.selected_measurement_point_id,
        measured_lux: this.measuredLux,
      };
      const currentIndex = this.measurement_points.findIndex(
        (point) =>
          point.measurement_point_id === this.selected_measurement_point_id
      );
      const nextIndex =
        this.measurement_points.length - 1 > currentIndex
          ? this.measurement_points.findIndex(
              (point, i) => point.is_active && i > currentIndex
            ) === -1
            ? this.measurement_points.findIndex((point) => point.is_active)
            : this.measurement_points.findIndex(
                (point, i) => point.is_active && i > currentIndex
              )
          : this.measurement_points.findIndex((point) => point.is_active);
      const id = this.measurement_points[nextIndex].measurement_point_id;
      const shouldDirectToRoomsList =
        this.isLastPointBeingMeasured && !this.existingResult;
      if (this.measuredLux === null && this.existingResult) {
        this.deleteIlluminationResult({
          illumination_test_id: this.selected_test_id,
          illumination_test_result_id:
            this.existingResult.illumination_test_result_id,
        });
      } else if (this.measuredLux !== null && !this.existingResult) {
        this.addIlluminationTestResult({
          illumination_test_id: this.selected_test_id,
          illumination_test_result,
        });
      } else if (this.measuredLux !== null) {
        this.updateIlluminationTestResult({
          illumination_test_id: this.selected_test_id,
          illumination_test_result_id:
            this.existingResult.illumination_test_result_id,
          illumination_test_result,
        });
      }
      this.setSelectedMeasurementPointId(shouldDirectToRoomsList ? null : id);
    },
    setExistingResult() {
      if (this.existingResult) {
        this.measuredLux = this.existingResult.measured_lux;
      } else {
        this.measuredLux = null;
      }
    },
  },
  watch: {
    selected_measurement_point_id() {
      this.setExistingResult();
    },
  },
  created() {
    this.setExistingResult();
  },
};
</script>
